import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/services/guards/auth.guard';
import { LoginComponent } from './layouts/login/login.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { DocumentsComponent } from './features/documents/documents.component';
import { HealthComponent } from './features/health/health.component';
import { ConnectionsComponent } from './features/connections/connections.component';
import { CalendarComponent } from './features/calendar/calendar.component';
import { ChatsComponent } from './features/chats/chats.component';
import { NotificationsComponent } from './features/notifications/notifications.component';
import { AudittrailsComponent } from './features/audittrails/audittrails.component';
import { SettingsComponent } from './features/settings/settings.component';
import { LogoutComponent } from './features/logout/logout.component';
import { ResetPasswordComponent } from './layouts/reset-password/reset-password.component';
import { RegisterComponent } from './layouts/register/register.component';
import { ForgotPasswordComponent } from './layouts/forgot-password/forgot-password.component';
import { MailVerificationComponent } from './layouts/mail-verification/mail-verification.component';
import { ProfileInformationComponent } from './features/settings/profile-information/profile-information.component';
import { SubscriptionComponent } from './features/settings/subscription/subscription.component';
import { CountryAffiliationComponent } from './features/settings/country-affiliation/country-affiliation.component';
import { HealthdashbordComponent } from './features/health/healthdashbord/healthdashbord.component';
import { HealthLogComponent } from './features/health/health-log/health-log.component';
import { CarePlanComponent } from './features/health/care-plan/care-plan.component';
import { MedicationComponent } from './features/health/medication/medication.component';
import { AllergyComponent } from './features/health/allergy/allergy.component';
import { AppointmentsComponent } from './features/appointments/appointments.component';
import { AppointmentHistoryComponent } from './features/appointments/appointment-history/appointment-history.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import { AuthInterceptor } from './AppHttpInterceptor';
import { AppComponent } from './app.component';
import { AppointmentSubscriptionComponent } from './features/appointments/subscription/subscription.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'documents', component: DocumentsComponent },
   { path: 'documents/:country', component: DocumentsComponent },
  // { path: 'health', component: HealthComponent },
  { path: 'appointments', component: AppointmentsComponent },
  { path: 'appointments/history', component: AppointmentHistoryComponent },   // target of goAppointmentHistory()
  { path: 'connections', component: ConnectionsComponent },
  { path: 'calendar', component: CalendarComponent },
  { path: 'chats', component: ChatsComponent },
  { path: 'notifications', component: NotificationsComponent },
  { path: 'audittrails', component: AudittrailsComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'mail-verification', component: MailVerificationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'profile', component: ProfileInformationComponent },
  { path: 'subscription', component: SubscriptionComponent },
  { path: 'country', component: CountryAffiliationComponent },
  // { path: 'payment', component: AppointmentSubscriptionComponent },

{ path: 'appointments/payment', component: AppointmentSubscriptionComponent }, // changed from 'payment'
  // { path: "dashbord", component: HealthdashbordComponent },
  // { path: "health-log", component: HealthLogComponent }, 
  // { path: "care-plan", component: CarePlanComponent },
  // { path: "medication", component: MedicationComponent },
  // { path: "allergy", component: AllergyComponent },
  // { path: "profile/:type", component: AllergyComponent },
  {
        path: 'health',
        loadChildren: () => import('./features/health/health.module')
          .then(m => m.HealthModule)
    },
  //{ path: 'logout', component: LogoutComponent },

  {
    path: 'register',
    loadChildren: () => import('./layouts/register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./layouts/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./layouts/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'mail-verification',
    loadChildren: () => import('./layouts/mail-verification/mail-verification.module').then(m => m.MailVerificationModule)
  },

  // Protected routes (authentication required)
  {
    path: '',
    //canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./features/dashboard/dashboard.module')
          .then(m => m.DashboardModule)
      },
      // {
      //   path: 'health',
      //   loadChildren: () => import('./features/health/health.module')
      //     .then(m => m.HealthModule)
      // },
      {
        path: 'appointments',
        loadChildren: () => import('./features/appointments/appointments.module')
          .then(m => m.AppointmentsModule)
      },
      {
        path: 'documents',
        loadChildren: () => import('./features/documents/documents.module')
          .then(m => m.DocumentsModule)
      },
      {
        path: 'connections',
        loadChildren: () => import('./features/connections/connections.module')
          .then(m => m.ConnectionsModule)
      },
      {
        path: 'calendar',
        loadChildren: () => import('./features/calendar/calendar.module')
          .then(m => m.CalendarModule)
      },
      {
        path: 'chats',
        loadChildren: () => import('./features/chats/chats.module')
          .then(m => m.ChatsModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('./features/notifications/notifications.module')
          .then(m => m.NotificationsModule)
      },
      {
        path: 'audittrails',
        loadChildren: () => import('./features/audittrails/audittrails.module')
          .then(m => m.AudittrailsModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./features/settings/settings.module')
          .then(m => m.SettingsModule)
      },
      {
        path: 'logout',
        loadChildren: () => import('./features/logout/logout.module')
          .then(m => m.LogoutModule)
      }
    ]
  },

  // Wildcard route for 404
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], // Removed `useHash: true` for clean URLs
  exports: [RouterModule],
  providers:[
        // provideClientHydration(),
        // provideHttpClient(withFetch()),
        DatePipe,
        DecimalPipe,
        ToastrService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // dd/MM/yyyy
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppRoutingModule { }